// ---------------------------------------------------------------------------
// The buttons by state — §17.3, as data
// ---------------------------------------------------------------------------
/** The secondary (ghost) button: *Message crew · Edit plan · Open the series · Message · Open the job*. */
export const HEADER_SECONDARY = ['message_crew', 'edit_plan', 'open_series', 'message', 'open_job'];
/** The green button: **Review & close · Schedule · Reschedule · Take off hold**. */
export const HEADER_PRIMARY = ['review_close', 'schedule', 'reschedule', 'take_off_hold'];
/** ⋯ (§7.2): *Add a day · Put on hold · Print the crew sheet · Copy link · Cancel the visit*. */
export const HEADER_MENU = ['add_day', 'put_on_hold', 'print_crew_sheet', 'copy_link', 'cancel_visit'];
/**
 * §17.3's table. The secondary and primary are the table's; which ⋯ items
 * each state offers is not in the contract's table and is read from §7.2,
 * §17.2 and §26.7 (*Add a day while the visit is open*; a closed or cancelled
 * visit is read-only; cancelling keeps a visit counted) — listed for the lead
 * to confirm in K3's report.
 */
const BY_STATUS = {
    unscheduled: { secondary: 'edit_plan', primary: 'schedule', menu: ['put_on_hold', 'copy_link', 'cancel_visit'] },
    scheduled: {
        secondary: 'message_crew', primary: 'review_close',
        menu: ['add_day', 'put_on_hold', 'print_crew_sheet', 'copy_link', 'cancel_visit'],
    },
    in_progress: {
        secondary: 'message_crew', primary: 'review_close',
        menu: ['add_day', 'put_on_hold', 'print_crew_sheet', 'copy_link', 'cancel_visit'],
    },
    completed: { secondary: 'message_crew', primary: 'review_close', menu: ['add_day', 'print_crew_sheet', 'copy_link'] },
    skipped: { secondary: 'open_series', primary: 'reschedule', menu: ['copy_link', 'cancel_visit'] },
    on_hold: { secondary: 'message', primary: 'take_off_hold', menu: ['copy_link', 'cancel_visit'] },
    closed: { secondary: 'open_job', primary: null, menu: ['copy_link'] },
    cancelled: { secondary: 'open_job', primary: null, menu: ['copy_link'] },
};
/** Write menu items — dropped for somebody who may not edit the visit. */
const WRITES = ['add_day', 'put_on_hold', 'cancel_visit'];
/**
 * The header's buttons for a visit (§17.3). *Open the series* shows on a
 * skipped visit only when it is part of a series; the green button needs
 * `can.close` for **Review & close** and `can.edit` for the others.
 */
export function headerButtons(input) {
    const row = BY_STATUS[input.status];
    const secondary = row.secondary === 'open_series' && !input.series ? null
        : row.secondary === 'edit_plan' && !input.can.edit ? null
            : row.secondary;
    const primary = row.primary === null ? null
        : row.primary === 'review_close' ? (input.can.close ? 'review_close' : null)
            : (input.can.edit ? row.primary : null);
    const menu = input.can.edit ? [...row.menu] : row.menu.filter((item) => !WRITES.includes(item));
    return { secondary, primary, menu };
}
// ---------------------------------------------------------------------------
// Tabs (do-not-substitute 3, §2.7, §5.1)
// ---------------------------------------------------------------------------
/** `?tab=` keys, in the tab row's order. */
export const VISIT_TAB_KEYS = [
    'overview', 'materials', 'equipment', 'time', 'money', 'for-crew', 'from-crew', 'activity', 'files', 'history',
];
//# sourceMappingURL=read.js.map